import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

function TabsItem() {
  return null;
}

function Tabs({ children }) {
  const items = useRef(React.Children.toArray(children));
  const [activeItem, setActiveItem] = useState();

  useEffect(() => {
    if (items) {
      const [firstItem] = items.current;

      setActiveItem(firstItem);
    }
  }, []);

  if (!(items || items.length)) return null;

  return (
    <div className="bg-big-stone dark:bg-gray-900 rounded">
      <div className="overflow-hidden px-3 pt-3">
        {items.current.map((item, index) => {
          const isActive = item === activeItem;

          return (
            <button
              key={index}
              onClick={() => setActiveItem(item)}
              className={classnames(
                'appearance-none dark:hover:text-white focus:outline-none text-sm py-2 px-3 font-medium duration-100 ease-in-out transition-opacity rounded uppercase tracking-wider',
                {
                  'text-white bg-light-bunting': isActive,
                  'text-light-haiti hover:text-white': !isActive,
                }
              )}
            >
              {item.props.label}
            </button>
          );
        })}
      </div>
      {items.current.map((item, index) => {
        const isActive = item === activeItem;

        return (
          <div
            key={index}
            className={classnames(item.props.className, 'overflow-auto', {
              hidden: !isActive,
            })}
          >
            {item.props.children}
          </div>
        );
      })}
    </div>
  );
}

export { Tabs, TabsItem };
